<template>
<!-- Site wrapper -->
<div class="wrapper">
  <cabecalho tituloPagina="Usuários" />
  <menuLateral />

  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6"></div>
        </div>
      </div><!-- /.container-fluid -->
    </section>
    <!-- Main content -->
    <section class="content">
      <!-- Default box -->
      <div class="row">
        <div class="col-md-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <div v-if="flagsDeControle.carregandoDados.status" class="d-flex align-items-center">
                <span class="avisoDanger">{{flagsDeControle.carregandoDados.mensagem}}</span>
                <b-spinner class="ml-2" variant="danger"></b-spinner>
              </div>
              <Informacoes :fotoUsuario="f_photo_usuario">
                <template #campos-adicionais>
                  <div class="form-group col-md-6 col-sm-12 col-xs-12 col-xl-6 col-lg-6">
                    <label for="inputTipoAcesso" class="required">Tipo de Acesso</label>
                    <b-form-select v-model="formulario.f_role" :options="comboTiposAcesso" value-field="valor" text-field="label" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" class="form-control comboFonteDefault" id="inputTipoAcesso"/>
                    <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.f_role}}</div>
                  </div>
                </template>
              </Informacoes>
            </div> <!-- card-body ends -->
            <div class="card-footer text-right">
              <div class="row btn-group btn-group-justified" role="group">
                <div class="mr-1"><b-button class="botoes" variant="outline-success btn-sm mt-2" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" @click="salvarRegistro()">Salvar</b-button></div>
                <router-link class="" to="/usuarios">
                  <b-button class="botoes" variant="outline-primary btn-sm mt-2" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">Cancelar</b-button>
                </router-link>
              </div>
            </div>
          </div> <!-- card ends -->
        </div>
      </div> <!-- row ends -->
    </section> <!-- /.content -->
  </div> <!-- /.content-wrapper -->
</div> <!-- ./wrapper -->
</template>

<script>
import Cadastro from './js/cadastro-usuarios'
export default Cadastro
</script>

<style scoped>
@import "./scss/usuarios.scss";
</style>
